import { render, staticRenderFns } from "./app-share.vue?vue&type=template&id=08d15d95"
import script from "./app-share.vue?vue&type=script&lang=js"
export * from "./app-share.vue?vue&type=script&lang=js"
import style0 from "./app-share.vue?vue&type=style&index=0&id=08d15d95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports